import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './components/ThemeProvider/ThemeProvider';
import { StyledEngineProvider } from '@mui/material';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './api/queryClient';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/Authorization/Login';
import AuthHeader from './components/Layouts/AuthHeader';
import ROUTES from './constants/routes';
import Recovery from './pages/Authorization/Recovery';
import EmailSent from './pages/Authorization/EmailSent';
import NewPass from './pages/Authorization/NewPass';
import ConfirmAsanImza from 'app/pages/Authorization/ConfirmAsanImza';
import OTP from './pages/Authorization/OTP';
import SelectCompany from './pages/Authorization/SelectCompany';
import DocSign from './pages/Authorization/DocSign';
import LinkConfirm from './pages/Authorization/LinkConfirm';
import MainLayout from './components/Layouts/MainLayout';
import HomePage from './pages/HomePage';
import TransferPage from './pages/TransferPage';
import PaymentOrdersPage from './pages/PaymentOrdersPage';
// import TemplatesPage from './pages/TemplatesPage';
import LastOperationsPage from 'app/pages/LastOperationsPage';
// import NewTemplatePage from 'app/pages/TemplatesPage/NewTemplatePage';
// import EditTemplate from 'app/pages/TemplatesPage/EditTemplate';
// import SignedOperationsPage from './pages/SignedOperationsPage';
import AccountsCardsPage from './pages/AccountsCardsPage';
import { LayoutProvider } from 'app/storage/LayoutContext';
// import CardOrderPage from 'app/pages/CardOrderPage';
// import SalaryPage from './pages/SalaryPage';
import ClientProfilePage from 'app/pages/ClientProfilePage';
// import EmployeeAddPage from 'app/pages/EmployeeAddPage';
// import CreditsPage from './pages/CreditsPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import InProgressPage from 'app/pages/InProgressPage';
import EmployeeAddPage from 'app/pages/EmployeeAddPage';
import TemplatesPage from 'app/pages/TemplatesPage';
import NewTemplatePage from 'app/pages/TemplatesPage/NewTemplatePage';
import EditTemplate from 'app/pages/TemplatesPage/EditTemplate';
import CreditsPage from 'app/pages/CreditsPage';
import SalaryPage from 'app/pages/SalaryPage';

const App = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider mode={'light'}>
        <StyledEngineProvider injectFirst>
          <QueryClientProvider client={queryClient}>
            <LayoutProvider>
              <BrowserRouter>
                <Routes>
                  <Route path={'/'} element={<Navigate to={'az/login'} replace />} />
                  <Route element={<AuthHeader />}>
                    <Route path={ROUTES.login} element={<Login />} />
                    <Route path={ROUTES.recovery} element={<Recovery />} />
                    <Route path={ROUTES.linkConfirm} element={<LinkConfirm />} />
                    <Route path={ROUTES.linkSent} element={<EmailSent />} />
                    <Route path={ROUTES.setNewPass} element={<NewPass />} />
                    <Route path={ROUTES.confirmAsanImza} element={<ConfirmAsanImza />} />
                    <Route path={ROUTES.otp} element={<OTP />} />
                    <Route path={ROUTES.selectCompany} element={<SelectCompany />} />
                    <Route path={ROUTES.docSign} element={<DocSign />} />
                  </Route>
                  <Route element={<MainLayout />}>
                    <Route path={ROUTES.homePage} element={<HomePage />} />
                    <Route path={ROUTES.transferPage} element={<TransferPage />} />
                    <Route path={ROUTES.paymentOrdersPage} element={<PaymentOrdersPage />} />
                    <Route path={ROUTES.clientProfile} element={<ClientProfilePage />} />
                    <Route path={ROUTES.lastOperations} element={<LastOperationsPage />} />
                    <Route path={ROUTES.accountsCards} element={<AccountsCardsPage />} />
                    <Route path={ROUTES.templatesPage} element={<TemplatesPage />} />
                    <Route path={ROUTES.newTemplate} element={<TransferPage />} />
                    <Route path={ROUTES.editTemplate} element={<TransferPage />} />
                    {/*<Route path={ROUTES.signedOperations} element={<SignedOperationsPage />} />*/}
                    {/*<Route path={ROUTES.cardOrder} element={<CardOrderPage />} />*/}
                    <Route path={ROUTES.salaryPage} element={<SalaryPage />} />
                    <Route path={ROUTES.employeeAdd} element={<EmployeeAddPage />} />
                    {/*<Route path={ROUTES.creditsPage} element={<CreditsPage />} />*/}
                  </Route>
                  <Route path={'*'} element={<NotFoundPage />}></Route>
                  {[
                    ROUTES.creditsPage,
                    // ROUTES.employeeAdd,
                    ROUTES.signedOperations,
                    // ROUTES.newTemplate,
                    // ROUTES.editTemplate,
                    // ROUTES.templatesPage,
                    ROUTES.cardOrder,
                    // ROUTES.salaryPage,
                    ROUTES.depositsPage,
                    ROUTES.ordersPage,
                    // ROUTES.lastOperations,
                    ROUTES.clientProfile
                  ].map((path, index) => (
                    <Route path={path} element={<InProgressPage />} key={index} />
                  ))}
                </Routes>
              </BrowserRouter>
            </LayoutProvider>
          </QueryClientProvider>
        </StyledEngineProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
